import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SelectItem } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { Rest } from 'app/rest/rest_client';
import { NotificationsService, Severity } from 'app/services/notifications-service/notifications.service';
import { AuthenticationService } from 'app/core/services/authentication/authentication.service';
import { I18nService } from 'app/services/i18n/i18n.service';
import { FinanceTypeService } from 'app/modules/vehicle-inventory/services/table-management/financing_type.service';

@Component({
    selector: 'app-finance-types-form',
    templateUrl: './finance-types-form.component.html',
    styleUrls: ['./finance-types-form.component.css'],
    providers: [FinanceTypeService],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FinanceTypesFormComponent
  extends EntityFormComponent<Rest.FinanceType>
  implements OnInit {

  noticeChannels: SelectItem[];
  channelsList: Rest.NoticeChannel[];
  title: string;

  active: boolean;


  /*Permissions */
  disableSave: boolean;
  disabeChangeStatus: boolean;

  constructor(
    private objectService: FinanceTypeService,
    notificationsService: NotificationsService,
    protected i18n: I18nService,
    private authenticationService: AuthenticationService,
    public translateService: TranslateService,
  ) {
    super(objectService, notificationsService, i18n, authenticationService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  /**
   * Loads and evaluates all the necessary data before showing the form.
   *
   * @memberof FinanceTypesFormComponent
   */
  beforeShow() {
    this.active = !this.entity.disabled;

	 //this.entity = {} as Rest.FinanceType;

    /*Permissions */
    if (this.isNew) {
      this.disableSave = false;
      this.title = this.translateService.instant('tableManagement.finances.createFinanceType');
    } else {
      this.title = this.translateService.instant('tableManagement.finances.editFinanceType');
      if (this.entity["_$update"] === true) {
        this.disableSave = false;
      } else {
        this.disableSave = true;
      }
      if (this.entity["_$changeStatus"] === true) {
        this.disabeChangeStatus = false;
      } else {
        this.disabeChangeStatus = true;
      }
    }
  }

  beforeSave() {
	console.log(this.entity);
  }
}
